// Play the Wilhelm scream, at most once per hold period.

import { SCREAM_HOLD_MS, SCREAM_URL } from './constants.js'

const audio = new Audio(SCREAM_URL)

let playing = false

/*
 * Prime the audio element from a user gesture, so later unattended
 * playback is allowed by autoplay policy.
 */
export const unlockAudio = async () => {
  audio.muted = true

  try {
    await audio.play()
  } catch {
    // Autoplay refusal here is fine; the gesture still unlocks audio.
  }

  audio.pause()
  audio.currentTime = 0
  audio.muted = false
}

/*
 * Play the scream unless it is already playing.
 */
export const playScream = () => {
  if (playing) {
    return
  }

  playing = true
  audio.play().catch(err => {
    console.error(`failed to play scream: ${err.message}`)
  })

  setTimeout(() => {
    playing = false
  }, SCREAM_HOLD_MS)
}
